export { ResultsPerPage } from './ResultsPerPage';
export type { ResultsPerPageProps } from './ResultsPerPage.types';
